/**
 * Who "we" are on the public pages — the landing page, the privacy policy and
 * the terms.
 *
 * <p>
 * ONE PLACE, because the same facts appear in all three and in the footer, and
 * Google's and Microsoft's reviewers read them side by side: a company name
 * spelled one way in the privacy policy and another in the terms is exactly the
 * kind of thing that gets a verification bounced.
 * </p>
 *
 * <p>
 * VALUES IN [SQUARE BRACKETS] ARE NOT CONFIRMED. They are left visibly
 * unfinished on purpose, so a page published before somebody fills them in
 * reads as a draft rather than quietly stating something untrue.
 * </p>
 */
export const COMPANY = {
  /** Product name, as customers see it on the Microsoft and Google consent screens. */
  product: 'My Stratum',
  /** Trading name. */
  name: 'Stratum',
  /** Registered legal entity — the party to the terms and the data controller. */
  // From stratum.ie: the footer (CRO, VAT), the contact and support pages, and
  // the website privacy policy ("Micronetwrx Technologies trading as Stratum").
  legalName: 'Micronetwrx Technologies Ltd',
  companyNumber: '435244',
  vatNumber: 'IE 9651880U',
  registeredAddress:
    'Unit B9, Ballymount Corporate Park, Ballymount Avenue Upper, Ballymount, Dublin 12, D12 ER82, Ireland',
  /** Where data is hosted. Shown in the privacy policy's transfers section. */
  hostingRegion: 'Microsoft Azure’s North Europe region, in Ireland',
  website: 'https://www.stratum.ie',
  portal: 'https://my.stratum.ie',
  phone: '+353 (0)1 405 0526',
  /** Live support hours, as stratum.ie/support states them. */
  supportHours: '09:00–18:00 Monday to Friday (closed 13:00–14:00), Irish time',
  /** stratum.ie publishes no separate privacy address, so data requests go to support. */
  privacyEmail: 'support@stratum.ie',
  supportEmail: 'support@stratum.ie',
  salesEmail: 'salesqueries@stratum.ie',
  /** Governing law and courts for the terms; the supervisory authority for the privacy policy. */
  jurisdiction: 'Ireland',
} as const;

/** Shown as "Last updated" on both legal pages. Change it whenever either text changes. */
export const LEGAL_LAST_UPDATED = '28 October 2026';

/** True when a value above is still a placeholder — used to avoid linking a mailto to "[...]". */
export function isPlaceholder(value: string): boolean {
  return value.startsWith('[');
}
